import actions from './actions'
import mutations from './mutations'

const state = {
  publishing: null,
  savingDraft: null,
  isSidebarOpen: false,
  postData: null
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
